import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Title } from "../../../../../../themes/Default/components/Title";
import { groupProgressManagement } from "../../../../../../hooks/api/GroupProgressManagement/GroupProgressManagement";
import { groupTypesManagement } from "../../../../../../hooks/api/GroupTypesManagement/GroupTypesManagement";
import { prepareSelect } from "../../../../../../services/core/Select";
import { Select } from "../../../../../../themes/Default/components/Form/components/Select";
import { toast } from "react-toastify";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";

const AddProgressType = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { groupProgressId } = useParams();
    const { groupProgressTypeId } = useParams();
    const [groupProgressName, setGroupProgressName] = useState("");
    const [groupTypes, setGroupTypes] = useState([]);

    const tabs = [
        { title: t("plans.title"), onClick: () => gotoPlansTab() },
        { title: t("groupTypes.title"), onClick: () => gotoTypeTab() },
        { title: t("groups.progress"), isActive: true },
        { title: t("groups.progressTest"), onClick: () => gotoProgressTestTab() },
    ];

    const gotoTypeTab = () => {
        navigate("/settings/groups/types");
    };

    const gotoPlansTab = () => {
        navigate("/settings/groups/plans");
    };
    
    const gotoProgressTestTab = () => {
        navigate("/settings/groups/progress-tests");
    };
    
    const { 
        useGroupTypesListMutation,
    } = groupTypesManagement;

    const { 
        useViewGroupProgressTypeMutation,
        useViewGroupProgressMutation,
        useUpdateGroupProgressTypeMutation
    } = groupProgressManagement;

    const [groupTypesList] = useGroupTypesListMutation();
    const [viewGroupProgressType] = useViewGroupProgressTypeMutation();
    const [viewGroupProgress] = useViewGroupProgressMutation();
    const [updateGroupProgressType] = useUpdateGroupProgressTypeMutation();

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = values;

        updateGroupProgressType({ body, groupProgressId, groupProgressTypeId }).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/groups/progress/" + groupProgressId + "/type/add");
            }
        });
    };

    useEffect(() => {
        groupTypesList().then((result) => {
            let options = [];
            result?.data?.records.map((groupType) => {
                options.push(
                    {
                        id: groupType.id,
                        name: groupType.name
                    }
                );
            })
            setGroupTypes(prepareSelect(options));
        });

        viewGroupProgress(groupProgressId).then((result) => {
            setGroupProgressName(result?.data?.name);
        });

        viewGroupProgressType({groupProgressId, groupProgressTypeId}).then((result) => {
            formRef.current.setValues(result?.data);
        });
     }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to={"/settings/groups/progress/" + groupProgressId + "/type/add"}/>
                <Button title={t('save')} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{groupProgressName}</Title>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("groups.title")} />
                    <Link title={t("Napredak")} />
                    <Link title={t('details')} isActive={true}/>
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        groupTypes: "", 
                        reportColumnTitle: ""
                    }}
                    onSubmit={(values) => {
                        onSaved(values);
                    }}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Select 
                                        name="groupTypes" 
                                        label={t("Tip grupe")}
                                        options={groupTypes}  
                                        selectedValue={values.groupTypes}
                                        onChange={(event) => {
                                            handleChange(event);
                                        }}
                                        error={formErrors?.groupTypes}
                                    />
                                </Field>
                                <Field></Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Input
                                        name="reportColumnTitle"
                                        label={t("Naslov u izvestaju za ovu kolonu")}
                                        required={true}
                                        value={values.reportColumnTitle}
                                        onChange={handleChange}
                                        error={formErrors?.reportColumnTitle}
                                    />
                                </Field>
                            </Row> 
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddProgressType;